module.exports = __webpack_public_path__ + "img/missionEnd-2-b.42ab49fa.png";